package features.profile.handlers

import AppState
import Router
import features.auth.data.UserRepository
import shared.ui.ModalManager

object ProfileHandlers {
    fun updateName(newName: String) {
        console.log("📝 Updating user name to:", newName)
        
        val user = AppState.currentUser ?: return
        
        // Update local state
        AppState.currentUser = user.copy(name = newName)
        
        // Update in Firestore
        UserRepository.createOrUpdateUser(AppState.currentUser!!)
            .then {
                console.log("✅ Name updated successfully")
                ModalManager.close()
                Router.render() // Re-render to show updated name
            }
            .catch { error ->
                console.error("❌ Error updating name:", error)
                kotlinx.browser.window.alert("Failed to update name")
            }
    }
    
    fun updateAvatar(newAvatar: String) {
        console.log("🖼️ Updating user avatar to:", newAvatar)
        
        val user = AppState.currentUser ?: return
        
        // Update local state
        AppState.currentUser = user.copy(avatar = newAvatar)
        
        // Update in Firestore
        UserRepository.createOrUpdateUser(AppState.currentUser!!)
            .then {
                console.log("✅ Avatar updated successfully")
                ModalManager.close()
                Router.render() // Re-render to show updated avatar
            }
            .catch { error ->
                console.error("❌ Error updating avatar:", error)
                kotlinx.browser.window.alert("Failed to update avatar")
            }
    }
}
